import PageResponse from "./page-response";
import Chat from "@/types/chat";
import React, {ReactNode} from "react";

export default interface Message {
    id: number;
    tempLocalId?: string;
    chatId?: string | number;
    repliedOn?: Message & { id: number | string };
    senderId: string;
    receiverId: string;
    senderFullName?: string | null;
    senderPicture?: string | null;
    text?: string | null;
    contentType: number;
    status: number;
    chatType: number;
    sendTime: number;
    viewCount: number;
    edited?: boolean;
    isDirect?: boolean;
    fileName?: string | null;
    filePath?: string | null;
    fileSize?: number | null;
    relatedTo?: string;
    relatedToLink?: string | null;
    filePreviewPath?: string | null;
}

export interface ITextMessage extends Message {
    text: string;
}

export enum ChatTypeEnum {
    User = 0,
    Channel = 1,
    Group = 2,
    Anonymous = 3,
}


export enum MessageStatus {
    SENDING = 0,
    UNSEEN = 1,
    SEEN = 2,
    ERROR,
}

export enum MessageContentType {
    UNKNOWN,
    TEXT,
    AUDIO,
    IMAGE,
    FILE,
    EMOJI
}

export interface GetMessagesResponseType extends PageResponse<Message[]> {
    data: Message[]
}

export interface GetMessageRequestType {
    pageNumber: number
    hostChatId: string,
    anonymousUserId?: string | null
}

export interface ReadMessageRequest {
    messageId: string | number;
    hostChatId: string | number
    anonymousUserId?: string | null
}

export interface AddMessageRequest {
    hostChatId: string;
    text?: string;
    file?: File;
    type: MessageContentType,
    repliedOn?: Message | null;
    sendTime: number,
    anonymousUserId?: string | null
}

export interface MessengerState {
    selectedChat: null | Chat,
    pagesToBeLoaded: number[],
    repliedOn: null | Message,
    chatIsLoading: boolean,
    lastUnseenMessageOnScreen: { messageId: number, chatId: string } | null,
    dockedSupportOpen: boolean

}

export interface MessageContentProps {
    id: number;
    hostChatId: string;
    filePreviewPath: string;
    filePath: string,
    fileName: string;
    contentType: MessageContentType;
    text: string,
    fileSize: string,
    senderId: string,
    isAtBottom: boolean,
    status: MessageStatus,
}

export interface MessageContextMenuProps {
    contextMenu: any,
    handleClose: () => void,
    handleReply: () => void,
    handleEditText: () => void,
    contentType: MessageContentType,
    isOthers: boolean,
    text: string,
    file?: { filePath?: string; fileName?: string; fileSize?: string; filePreviewPath?: string };
    hostChatId: string,
    id: number,
}

export interface SendToMultipleChatsDialogProps {
    open: boolean;
    onClose: () => void;
    chats: Chat[];
    onConfirm: (
        selectedUserIds: string[],
        message: {
            text?: string;
            file?: {
                filePath?: string;
                fileName?: string;
                fileSize?: number;
                filePreviewPath?: string;
            };
            id: number;
            contentType: MessageContentType;
        }
    ) => void;
    message: {
        text?: string;
        file?: {
            filePath?: string;
            fileName?: string;
            fileSize?: number;
            filePreviewPath?: string;
        };
        id: number;
        contentType: MessageContentType;
    };
    selectedUserIds: string[];
    setSelectedUserIds: React.Dispatch<React.SetStateAction<string[]>>;
}


export interface MessageEditFormProps {
    text: string,
    id: number,
    isEditingText: boolean,
    setIsEditingText: (isEditingText: boolean) => void,
}

export interface MessageInfoProps {
    isImage: boolean;
    chatType: number,
    status: MessageStatus,
    viewCount: number,
    edited: boolean,
    isOthers: boolean,
    time: string,
    id: number,
}

export interface MessageRelatedToProps {
    relatedToLink: string;
    relatedTo: string;
    isOthers: boolean;
}


export interface MessageWrapperProps {
    isOthers: boolean;
    chatType: number;
    senderPicture: string;
    senderFullName: string;
    contentType: number;
    isEmoji: boolean;
    showTail: boolean;
    children: ReactNode;
}


export interface ConversationScrollContainerProps {
    canSendMessage?: boolean
}

export interface ConversationScrollContainerRef {
    scrollToBottom: () => void
}

export interface ConversationMessagePageProps {
    isAtBottom: boolean
    pageNumber: number
    topRef: React.MutableRefObject<HTMLDivElement | null>
    bottomRef: React.MutableRefObject<HTMLDivElement | null>
    scrollContainerRef?: React.MutableRefObject<HTMLDivElement | null>
    dateTrackerRef: React.MutableRefObject<string>
}

export type WaveSurferInstance = {
    load: (url?: string) => void;
    playPause: () => void;
    on: (event: string, callback: (...args: any[]) => void) => void;
    getDuration: () => number;
    getCurrentTime: () => number;
};

